import { StorageService } from 'src/app/_services/storage.service';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Routes } from 'src/app/_config/routes.config';
import { AttachedFilesModule } from 'src/app/_models/attached-files-module.model';
import { AttachedFilesService } from '../../../_services/attached-files.service';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { StateTransitionsModel } from 'src/app/_models/state-transitions.model';
import { ClaimOperationCP } from 'src/app/_models/claim-operation-cp.model';
import { ClaimOperationCPService } from 'src/app/_services/claim-operation-cp.service';
import { DynamicFormService } from 'src/app/_services/dynamic-form.service';
import { ConfirmTransitionResponse } from 'src/app/_models/Confirm-transition-response.model';
import { StateMasterService } from 'src/app/_services/state-master.service';
import { ElementRequiredLinkedStates } from 'src/app/_models/elementRequiredLinkedStates.model';
import { RequiredDocuments } from 'src/app/_models/required-documents.model';
import { CommerceFiles } from 'src/app/_models/commerce-files.model';
import { Contact } from 'src/app/_models/contact.model';
import { CommerceFilesService } from 'src/app/_services/commerce-files.service';
import { ContactService } from 'src/app/_services/contact.service';
import { DownloadFileComponent } from '../../download-file/download-file.component';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';

declare var bootstrap: any;

@Component({
  selector: 'DCO-disputes-Management',
  templateUrl: './disputes-management.component.html',
  standalone: false,
})
export class DisputesManagementComponent
  extends BaseComponent
  implements OnInit
{
  @Input() claimId: string;
  @Input() claimOperations: ClaimOperationCP[] = [];
  @Input() claimOperationId: string;
  @Input() claimOperationIds: string[] = [];
  @Input() stateTransitionsRes: StateTransitionsModel[] = [];
  @Input() isMassive: boolean; // Visualizar botones de aceptar disputa parcial y no aceptar solo en el caso de que estemos en la pantalla de editar.
  @Input() claimIds: string[]; // Necesitamos los claimId para mostrar los documentos de cada disputa

  @Input() transitionsLoaded: boolean;
  @ViewChild('modalFileInput') modalFileInput: ElementRef;
  @ViewChild(DownloadFileComponent)
  downloadFileComponent: DownloadFileComponent;

  @ViewChild(DynamicFormComponent) myFormGroup!: DynamicFormComponent;

  // attachmentGrid.start
  page = 1;
  currentFormats: any;
  // attachmentGrid.end

  confirmDisputP: boolean = false;
  attachedFilesInfo: AttachedFilesModule[] = [];
  confirmDispute = false;
  buttonsShow;
  dynamicFormId: number = 0;
  lastRequiredElementsString: string;
  lastRequiredElements = [];
  formData = new FormData();
  showInternational: string = '';

  //Variables subida archivo
  requiredDocuments: RequiredDocuments[];
  fileList: FileList;
  index: number;
  fileRefs = {};
  finalStateDyf: number = 0;
  finalStateAccept: number = 0;
  comments: string = '';

  //Variables transición de estado
  confirmTransitionResponse: ConfirmTransitionResponse;
  comprobation: boolean = undefined;
  //Formularios
  modalTitleStateName = '';
  combinedForm: FormGroup;

  //Variables desplegable de commerceFiles
  commerceFilesByType: { [key: string]: CommerceFiles[] } = {};
  commerceFile: CommerceFiles;
  contactIdGuid: string = '';
  contact: Contact[] = [];
  claimOperation: ClaimOperationCP[] = [];
  /*   contactParameters: any = {
    page: 1,
    pageSize: 100,
    search: '',
    order: '',
  }; */
  // claimOperationsParameters: any = {
  //   search: [],
  //   top: 0,
  //   order:   {by: 'ClaimOperationID',
  // ordering: 'DESC' },
  //   boolOperator: "AND"
  // };

  commerceFileDownloads: CommerceFiles[] = [];

  constructor(
    private readonly fb: FormBuilder,
    public override router: Router,
    public override langService: LanguageManagerService,
    private AttachedFilesService: AttachedFilesService,
    private StorageService: StorageService,
    private ClaimOperationCPService: ClaimOperationCPService,
    private stateMasterService: StateMasterService,
    private route: ActivatedRoute,
    private DynamicFormService: DynamicFormService,
    private CommerceFilesService: CommerceFilesService,
    private ContactService: ContactService,
  ) {
    super(router, langService, route);
  }

  override ngOnInit(): void {
    this.currentFormats =
      this.langService.dateAndCurrencyChangeFormat$.subscribe((formats) => {
        this.currentFormats = formats; // Guardamos los formatos actualizados para utilizarlos
      });
    this.CombinedForms();

    // const filterClaimOp = {
    //     identifier: "ClaimOperationID",
    //     value: this.claimOperationId,
    //     type: 'int',
    //     operator: "="
    // };

    // if (!Array.isArray(this.claimOperationsParameters.search)) {
    //     this.claimOperationsParameters.search = [];
    //   }

    // this.claimOperationsParameters.search.push(filterClaimOp);

    //this.claimOperationsParameters.search = `ClaimOperationId=${this.claimOperationId}`;
  }
  loadingTransitions = true;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['transitionsLoaded']) {
      this.loadingTransitions = changes['transitionsLoaded'].currentValue;
    }
    if (changes['stateTransitionsRes']) {
      this.buttonsShow = new Array(this.stateTransitionsRes.length);
      for (let i = 0; i < this.stateTransitionsRes.length; i++) {
        this.buttonsShow[i] = this.stateTransitionsRes[i].state_Name;
      }
    }
    if (changes['claimOperations']) {
      if(this.claimOperations != null){
        this.showInternational = this.claimOperations[0].compensation;
      }


      //Se obtiene el objeto con los archivos requeridos
      let claimid = '0';
      let claimOperationId = '0';
      if (this.claimOperations && this.claimOperations.length > 0) {
        ((claimid = this.claimOperations[0].claimID),
          (claimOperationId = this.claimOperations[0].claimOperationID));
        this.contactIdGuid = this.claimOperations[0].contactIdGuid;
        this.ClaimOperationCPService.GetClaimOperationByUser(
          claimOperationId,
        ).subscribe({
          next: (response) => {
            this.lastRequiredElementsString = response;
            //Para la pagina de massive-information
            if (this.isMassive) {
              //console.log(this.isMassive)
              // Filtramos para obtener solo claimIds únicos
              this.claimIds = Array.from(new Set(this.claimIds));
              this.claimIds.forEach((claimId) => {
                this.AttachedFilesService.AttachedFiles_GetByClaim(
                  claimId,
                ).subscribe(
                  (attached) => {
                    this.attachedFilesInfo =
                      this.attachedFilesInfo.concat(attached);
                  },
                  (error) => {},
                );
              });
            } //Para la pagina de claim-client-edit
            else {
              this.AttachedFilesService.AttachedFiles_GetByClaim(
                this.claimId,
              ).subscribe(
                (attached) => {
                  this.attachedFilesInfo = attached;
                  //Se establece el contador para determinar la posición del documento
                  let counter = 0;
                  let deletes = 0;
                  //Se transforma el script que contiene los documentos en objeto
                  if (
                    this.lastRequiredElementsString &&
                    this.lastRequiredElementsString != ''
                  ) {
                    if (typeof this.lastRequiredElementsString === 'string') {
                      this.lastRequiredElements = JSON.parse(
                        this.lastRequiredElementsString,
                      );
                    } else {
                      this.lastRequiredElements =
                        this.lastRequiredElementsString;
                    }
                    //console.log(this.lastRequiredElements)
                    if (!Array.isArray(this.lastRequiredElements)) {
                      this.lastRequiredElements = [];
                    }
                    /*Se compara el Guid de los documentos del objeto de archivos requeridos con el Guid del
                  los documentos del objeto que muestra todos los documentos subidos de esa disputa para
                  comprobar si los archivos requeridos se encuentran ya subidos*/
                    this.lastRequiredElements.forEach((element) => {
                      this.attachedFilesInfo.every((element2) => {
                        if (element.uid == element2.attachedFileID) {
                          /*En aquellos documentos con coincidencia se añade la propiedad uploaded al objeto
                        de documentos requeridos*/
                          this.lastRequiredElements[counter].uploaded = true;
                          this.requiredDocuments[counter].received = true;
                          this.requiredDocuments[counter].IsUploadedTrue = true;
                          this.requiredDocuments[counter].IsCommerceFile =
                            false;
                          deletes++;
                          //Se devuelve falso cuando hay coincidencia para romper bucle y optimizar
                          return false;
                        }
                        return true;
                      });
                      counter++;
                    });
                  }
                },
                (error) => {},
              );
            }
          },
        });
      }
    }
  }

  // Recuperar dias restantes para grid de Documentacion disputa
  CalculateDaysRemaining(createdDateString: string) {
    let createdDate: Date = new Date(createdDateString);
    let currentDate: Date = new Date();
    let timeDifference: number = createdDate.getTime() - currentDate.getTime();
    let daysDifference: number = Math.ceil(timeDifference / (1000 * 3600 * 24));
    if (daysDifference < 0) {
      daysDifference = 0;
    }
    return daysDifference.toString();
  }

  // *** Descargar archivo del grid de attachments
  DownloadAttachment(attachedFileID: string) {
    this.AttachedFilesService.AttachedFiles_GetBase64(attachedFileID).subscribe(
      (attached) => {
        if (attached && attached.base64) {
          const byteArray = this.base64ToUint8Array(attached.base64);

          let ab: ArrayBuffer;
          if (byteArray.buffer instanceof ArrayBuffer) {
            ab = byteArray.buffer;
          } else {
            // (raro) fallback si el motor te diera SAB
            const copy = new ArrayBuffer(byteArray.byteLength);
            new Uint8Array(copy).set(byteArray);
            ab = copy;
          }

          const blob = new Blob([ab], {
            type: 'application/octet-stream',
          });

          // Aseguramos que la extensión tiene un punto al principio.
          const extension = attached.extension.startsWith('.')
            ? attached.extension
            : `.${attached.extension}`;
          // Si el nombre ya contiene la extensión bien, dejamos el nombre tal cual. Si no, añadimos la extensión, asegurando que siempre tenga un punto antes.
          const fileName = attached.name
            .toLowerCase()
            .endsWith(extension.toLowerCase())
            ? attached.name
            : `${attached.name}${extension}`;
          this.triggerDownload(blob, fileName);
          // this.triggerDownload(blob, `${attached.name}${attached.extension}`);
        }
      },
      (error) => {
        if (error.status === 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      },
    );
  }

  // Convertir base64 a Uint8Array
  base64ToUint8Array(base64: string): Uint8Array {
    const binaryString = atob(base64); // Decodificamos el base64 a cadena binaria
    const byteArray = new Uint8Array(binaryString.length); // Creamos un array de bytes
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i); // Almacenamos cada byte en el array
    }
    return byteArray;
  }

  // Iniciar la descarga del archivo
  triggerDownload(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href); // Limpiamos la URL temporal
  }

  //calcula la clase de los botones segun si es final fav, desfav o neutro
  GetButtonClass(button: StateTransitionsModel): string {
    switch (button.state_FinalStatus) {
      case 3: // N/A
        return 'btn btn-default';
      case 1: // ganado
        return 'btn btn-primary text-sm fw-semibold';
      case 2: // perdido
        return 'btn btn-outline-primary text-sm fw-semibold';
      case 0: // neutro
        return 'btn btn-primary text-sm fw-semibold';
    }
    return '';
  }

  //***Formularios al aceptar disputa parcial o no aceptar.
  CombinedForms() {
    this.combinedForm = this.fb.group({
      partialForm: this.fb.group({
        validateRefund: [null, Validators.required],
        amount: ['', Validators.required],
        reasonDispute: ['', Validators.required],
      }),
      rejectForm: this.fb.group({
        validateRefund: [null, Validators.required],
        notAccept: ['', Validators.required],
      }),
      billingDetails: this.fb.group({
        ncustomer: ['', Validators.required],
        sncustomer: ['', Validators.required],
        adress: ['', Validators.required],
        city: ['', Validators.required],
        state: ['', Validators.required],
        country: ['', Validators.required],
        PC: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        IP: ['', Validators.required],
        phone: ['', Validators.required],
        DNI: ['', Validators.required],
      }),
      shippingDetails: this.fb.group({
        ncustomerShipping: ['', Validators.required],
        sncustomerShipping: ['', Validators.required],
        adressShipping: ['', Validators.required],
        cityShipping: ['', Validators.required],
        stateShipping: ['', Validators.required],
        countryShipping: ['', Validators.required],
        PCShipping: ['', Validators.required],
        trakingNumber: ['', Validators.required],
        transportCompany: ['', Validators.required],
        deliveryDate: ['', Validators.required],
        deliveryStatus: ['', Validators.required],
      }),
    });
  }

  get partialForm(): FormGroup {
    return this.combinedForm.get('partialForm') as FormGroup;
  }

  get rejectForm(): FormGroup {
    return this.combinedForm.get('rejectForm') as FormGroup;
  }

  SubmitPartial() {
    if (
      this.partialForm.valid &&
      this.combinedForm.get('billingDetails').valid &&
      this.combinedForm.get('shippingDetails').valid
    ) {
      const partialData = {
        ...this.partialForm.value,
        ...this.combinedForm.get('billingDetails').value,
        ...this.combinedForm.get('shippingDetails').value,
      };
    } else {
      console.error('Partial Form is not valid');
    }
  }

  SubmitReject() {
    if (
      this.rejectForm.valid &&
      this.combinedForm.get('billingDetails').valid &&
      this.combinedForm.get('shippingDetails').valid
    ) {
      const rejectData = {
        ...this.rejectForm.value,
        ...this.combinedForm.get('billingDetails').value,
        ...this.combinedForm.get('shippingDetails').value,
      };
    }
  }

  loadInfoFiles(){
    const documentsStorage = localStorage.getItem(
      'Documents_' + this.claimOperationId
    );

    if (documentsStorage) {
      const storedDocuments = JSON.parse(documentsStorage);

      storedDocuments.forEach((storedDocument) => {
        const document = this.requiredDocuments.find(
          (d) => d.type === storedDocument.type
        );

        if (document) {
          Object.assign(document, storedDocument);
        } else {
          this.requiredDocuments.push(storedDocument);
        }
      });
    }
  }

  saveInfoFiles(){
    localStorage.setItem('Documents_'+this.claimOperationId,JSON.stringify(this.requiredDocuments.filter((requireDocument) => requireDocument.uploaded)));
  }

  // gestion de acciones segun el tipo de botón
  // si es un estado intermedio, se muestran los archivo y los formularios asociados
  ClickActionButton(button: StateTransitionsModel, i: number) {
    // si es un estado de final se muestra el popup de aviso
    //console.log(button)
    if (button.state_FinalStatus == 2) {
      this.confirmDisputP = false;
      this.finalStateAccept = button.stateId;
      this.modalTitleStateName = button.state_Name;
      let myModal = new bootstrap.Modal('#confirmModal');
      myModal.show();
      this.lastRequiredElements = [];
      return;
    }
    let hasOtherDocumentsRequested = false;
    this.finalStateDyf = button.stateId;
    //this.lastRequiredElements = [];
    this.requiredDocuments = [];
    this.lastRequiredElements.forEach((element) => {
      if (element.name == 'OTHER_DOCUMENTS') {
        hasOtherDocumentsRequested = true;
      }
      let requiredDocument = new RequiredDocuments();
      requiredDocument.type = element.name;
      requiredDocument.id = +element.id;
      requiredDocument.uid = element.uid;
      requiredDocument.uploaded = false;
      requiredDocument.required = true;
      requiredDocument.IsCommerceFile = this.IsCommerceFileType(element.name);
      requiredDocument.IsUploadedTrue = false;
      this.requiredDocuments.push(requiredDocument);
    });
    this.stateMasterService
      .GetLinkedElementStates(button.stateId.toString())
      .subscribe((elements) => {
        // solo rellenamos si previamente no se ha rellenado con lastrequiredelements
        if (this.requiredDocuments.length == 0) {
          elements.map((element) => {
            if (element.elementName == 'OTHER_DOCUMENTS') {
              hasOtherDocumentsRequested = true;
            }
            let requiredElement = new ElementRequiredLinkedStates();
            requiredElement.name = element.elementName;
            requiredElement.id = element.elementLinkedStateId;
            requiredElement.uid = element.uid;
            this.lastRequiredElements.push(requiredElement);
            let requiredDocument = new RequiredDocuments();
            requiredDocument.type = element.elementName;
            requiredDocument.id = 0;
            requiredDocument.uid = element.uid;
            requiredDocument.uploaded = false;
            requiredDocument.required = true;
            requiredDocument.IsCommerceFile = false;
            requiredDocument.IsUploadedTrue = false;
            this.requiredDocuments.push(requiredDocument);
          });
        }
        let counter = 0;
        let deletes = 0;

        //console.log(this.stateTransitionsRes, i)
        if (
          this.confirmDisputP == false &&
          this.stateTransitionsRes[i].documents.length > 0
        ) {
          this.confirmDisputP = true;
          this.dynamicFormId = button.documents[0].dynamicFormId;
        }

        /*Recuperamos el commerceNumber de la disputa para recuperar los datos del contacto y asi filtrar
         los commerceFiles por el contactIdGuid */
        const types = [
          ...new Set(this.requiredDocuments.map((doc) => doc.type)),
        ];

        // CommerceFiles commercenumber
        this.FillCommerceFiles(types);
        //this.getClaimOperation(this.claimOperationsParameters, types);
      });

    if (!hasOtherDocumentsRequested) {
      let requiredDocument = new RequiredDocuments();
      requiredDocument.type = 'OTHER_DOCUMENTS';
      requiredDocument.id = 0;
      requiredDocument.uid = this.StorageService.getGuid();
      requiredDocument.uploaded = false;
      requiredDocument.required = false;
      requiredDocument.IsCommerceFile = this.IsCommerceFileType(
        requiredDocument.type,
      );
      requiredDocument.IsUploadedTrue = false;
      this.requiredDocuments.push(requiredDocument);
    }
    let myModal = new bootstrap.Modal('#modalPop2');
    myModal.show();
    this.loadInfoFiles();
    //this.lastRequiredElements = [];
    return;
  }
  AddNewOtherDocumentLine() {
    let requiredDocument = new RequiredDocuments();
    requiredDocument.type = 'OTHER_DOCUMENTS';
    requiredDocument.id = 0;
    requiredDocument.uid = this.StorageService.getGuid();
    requiredDocument.uploaded = false;
    requiredDocument.required = false;
    requiredDocument.IsCommerceFile = this.IsCommerceFileType(
      requiredDocument.type,
    );
    requiredDocument.IsUploadedTrue = false;
    this.requiredDocuments.push(requiredDocument);
  }
  IsCommerceFileType(type: string) {
    return Object.values(DocumentType).includes(type);
  }

  confirmDisputeAct(stateNameKey: string, document: any, i: number) {
    if (
      this.confirmDisputP == false &&
      this.stateTransitionsRes[i].documents.length > 0
    ) {
      this.confirmDisputP = true;
      this.dynamicFormId = document.dynamicFormId;
    } else {
      this.confirmDisputP = false;
      this.modalTitleStateName = stateNameKey;
      let myModal = new bootstrap.Modal('#confirmModal');
      myModal.show();
    }
  }

  receriveDisputeAct($event) {
    this.confirmDisputP = $event;
  }

  onModalDocumentUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) {
      return;
    } else {
      const files: File[] = Array.from(input.files);
      files.forEach((file,index) => {
          const indexExt = this.index;
          if (index>0){
            this.AddNewOtherDocumentLine()
          }
          this.requiredDocuments[indexExt].sizeInKbs = Math.round(
            file.size / 1024,
          );
          this.requiredDocuments[indexExt].size = file.size;
          this.requiredDocuments[indexExt].name = file.name;
          this.requiredDocuments[indexExt].documentType = file.type;
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.requiredDocuments[indexExt].documentBase64 = reader.result
              .toString()
              .replace('data:', '') // el reader devuelve el string como data:<type>;base64,wL2dvYWwgbW9yZ...
              .replace(/^.+,/, ''); // quitamos lo que sobra
            this.requiredDocuments[indexExt].uploaded = true;
            this.requiredDocuments[indexExt].IsUploadedTrue = true;
            this.requiredDocuments[indexExt].IsCommerceFile = false;
            this.fileRefs[file.name] = this.requiredDocuments[indexExt].uid;
          };
          this.requiredDocuments = [...this.requiredDocuments];
          this.index++
        });
      //const file = input.files[0];
      
    }
  }

  ClearUploadedDocument(i) {
    this.requiredDocuments[i].uploaded = false;
    this.requiredDocuments[i].documentBase64 = '';
    this.requiredDocuments[i].IsUploadedTrue = false;
    this.requiredDocuments[i].name = '';
    this.requiredDocuments[i].documentType = '';
    this.modalFileInput.nativeElement.value = '';
    this.requiredDocuments = [...this.requiredDocuments];
  }

  getIndex(i) {
    this.index = i;
  }

  blockAcceptButton = false;
  listErrorAccept = [];
  showErrorAccept = false;
  AcceptDisputeTotal() {
    this.blockAcceptButton = true;
    this.listErrorAccept = [];
    this.showErrorAccept = false;
    this.formData = new FormData();
    this.formData.append('claimOperations', this.claimOperationId);
    this.formData.append('stateId', this.finalStateAccept.toString());
    //Si los documentos necesarios están subidos se llama al endpoint de transición
    this.DynamicFormService.postItem(this.formData).subscribe({
      next: (confirmation) => {
        this.confirmTransitionResponse = confirmation;
      },
      error: (response) => {
        this.showErrorAccept = true;
        if (response.status == 409) {
          this.listErrorAccept = [];
          let confirmResponseObject =
            response.error as ConfirmTransitionResponse;
          confirmResponseObject.listFileError.map((fileError) => {
            this.listErrorAccept.push(
              this.langService
                .translate(fileError.errorMsg)
                .replace('{0}', fileError.fileName),
            );
          });
          confirmResponseObject.claimOperationPermissionsError.map(
            (permissionError) => {
              this.listErrorAccept.push(
                this.langService
                  .translate(permissionError.errorMsg)
                  .replace('{0}', permissionError.claimOperationId.toString()),
              );
            },
          );
          confirmResponseObject.claimOperationProcessingError.map(
            (processingError) => {
              this.listErrorAccept.push(
                this.langService
                  .translate(processingError.errorMsg)
                  .replace('{0}', processingError.claimOperationId.toString()),
              );
            },
          );
          if (this.listErrorAccept.length == 0) {
            let errorMessage = '';
            if (
              confirmResponseObject.hasOwnProperty('logId') &&
              confirmResponseObject.logId
            ) {
              errorMessage = confirmResponseObject.logId.toString();
            }
            this.listErrorAccept.push(
              this.langService
                .translate('@@CMP.Error_Server')
                .replace('{0}', errorMessage),
            );
          }
        } else if (response.status == 500) {
          // error de servidor
          let errorMessage = '';
          if (response.error.hasOwnProperty('detail')) {
            errorMessage = response.error['detail'];
          }
          this.listErrorAccept.push(
            this.langService
              .translate('@@CMP.Error_Server')
              .replace('{0}', errorMessage),
          );
        } else {
          let errorMessage = '';
          if (response.error.hasOwnProperty('detail')) {
            errorMessage = response.error['detail'];
          }
          // error no identificado
          this.listErrorAccept.push(
            this.langService
              .translate('@@CMP.Error_Undefined')
              .replace('{0}', errorMessage),
          );
        }
        this.blockAcceptButton = false;
      },
      complete() {
        window.location.reload();
      },
    });
  }

  loadCommerceFiles(docType: string, contactIdGuid: string) {
    this.CommerceFilesService.getAll(docType, contactIdGuid).subscribe({
      next: (res) => {
        this.commerceFilesByType[docType] = res ?? [];
        if (this.requiredDocuments?.length) {
          this.preselectSingleOptions();
        }
      },
      error: (err) => {
        console.error(
          `Error cargando archivos del comercio para tipo ${docType}`,
          err,
        );
        this.commerceFilesByType[docType] = [];
      },
    });
  }

  FillCommerceFiles(types: string[]) {
    //console.log(this.contactIdGuid)
    types.forEach((type) => {
      this.loadCommerceFiles(type, this.contactIdGuid);
    });
  }

  preselectSingleOptions() {
    this.requiredDocuments.forEach((doc, i) => {
      if (doc.type != 'OTHER_DOCUMENTS') {
        const files = this.commerceFilesByType[doc.type];
        if (files && files.length === 1 && !doc.IsUploadedTrue) {
          const selectedFileId = files[0].commerceFileId;
          this.requiredDocuments[i].id = selectedFileId;
          this.SelectedDll(i, selectedFileId.toString());
        }
      }
    });
  }

  SelectedDll(index: number, ddl_selectedValue: string) {
    if (ddl_selectedValue === '') {
      this.requiredDocuments[index].uploaded = false;
      this.requiredDocuments[index].IsCommerceFile = false;
      this.requiredDocuments[index].IsUploadedTrue = false;
      this.requiredDocuments[index].name = '';
      this.requiredDocuments[index].id = 0;
    } else {
      //Recuperamos el nombre del archivo para mostrar cual se ha adjuntado
      const selectedDoc = this.commerceFilesByType[
        this.requiredDocuments[index].type
      ].find((doc) => doc.commerceFileId === parseInt(ddl_selectedValue, 10));
      this.requiredDocuments[index].uploaded = true;
      this.requiredDocuments[index].IsCommerceFile = true;
      this.requiredDocuments[index].IsUploadedTrue = true;
      this.requiredDocuments[index].size = 0;
      this.requiredDocuments[index].name = selectedDoc.fileName;
      this.requiredDocuments[index].id = parseInt(ddl_selectedValue, 10);
    }
    this.requiredDocuments = [...this.requiredDocuments];
  }

  removeSelected(index: number) {

    if(this.requiredDocuments[index].type ==='OTHER_DOCUMENTS' && this.requiredDocuments.filter(document => document.type === 'OTHER_DOCUMENTS').length>1)
    {
      this.requiredDocuments.splice(index, 1);
      this.requiredDocuments = [...this.requiredDocuments];
    } else 
    {
      this.requiredDocuments[index].id = 0;
      this.requiredDocuments[index].uploaded = false;
      this.requiredDocuments[index].IsCommerceFile = false;
      this.requiredDocuments[index].IsUploadedTrue = false;
      this.requiredDocuments[index].documentType = '';
      this.requiredDocuments = [...this.requiredDocuments];
    }

  }

  downloadCommerceFile(commerceFileId: number) {
    this.CommerceFilesService.getVersions(commerceFileId).subscribe({
      next: (res) => {
        const downloads = res.data;
        //console.log("download", downloads);
        if (downloads && downloads.length > 0) {
          const latestFile = downloads[0];
          if (this.downloadFileComponent) {
            this.downloadFileComponent.fileId =
              latestFile.commerceFileHistoricID;
            this.downloadFileComponent.downloadFile();
          }
        }
      },
      error: (error) => {
        console.error('Error al obtener versiones del archivo', error);
      },
    });
  }
  onSave(): void {
    this.myFormGroup.saveInfoForm();
    this.saveInfoFiles();
    this.onCancel()
  }
  onSubmit(): void {
    this.myFormGroup.onCommitResponses();
  }
  onCancel(): void {
    const modalElement = document.getElementById('modalPop2');
    const myModal = bootstrap.Modal.getInstance(modalElement);

    myModal?.hide();
  }

  viewDocument(index: number) {

    const document = this.requiredDocuments[index];

    const byteCharacters = atob(document.documentBase64);
    const byteArray = Uint8Array.from(
      byteCharacters,
      char => char.charCodeAt(0)
    );

    const blob = new Blob([byteArray], {
      type: document.documentType
    });

    const url = URL.createObjectURL(blob);

    window.open(url, '_blank');

    setTimeout(() => URL.revokeObjectURL(url), 1000);

  }
}
